import {
  mxCell, mxCellState, mxFastOrganicLayout as MxFastOrganicLayout, mxRectangle,
} from 'mxgraph-js';
import HCLTreeMxGraph, { HCLTreeMxGraphJSON } from './HCLTreeMxGraph';
import ReferenceTypes from '../HCLTreeNode/HCLTreeVertexValue/ReferenceTypes';
import { OutcomeJSON } from '../HCLTreeNode/HCLTreeVertexValue/Outcome';
import { ExpressionJSON } from '../HCLTreeNode/HCLTreeVertexValue/Expression';
import BayesianNetworkVertex from '../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertex';
import BayesianNetworkMxGraphDecoder from '../HCLTreeMxGraphDecoder/BayesianNetworkMxGraphDecoder';
import BayesianNetworkMxGraphEncoder from '../HCLTreeMxGraphEncoder/BayesianNetworkMxGraphEncoder';
import { LabelJSON } from '../HCLTreeNode/HCLTreeVertexValue/Label';
import BayesianNetworkMxVertexHandler from '../VertexHandler/BayesianNetworkMxVertexHandler';
import BayesianNetworkMxStylesheet from '../Stylesheet/BayesianNetworkMxStylesheet';
import BayesianNetworkMxCellRenderer from '../HCLCellRenderer/BayesianNetworkMxCellRenderer';
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';
import BayesianNetworkMxGraphModel from '../HCLMxGraphModel/BayesianNetworkMxGraphModel';
import BayesianNetworkMxGraphSelectionModel from '../HCLMxGraphSelectionModel/BayesianNetworkMxGraphSelectionModel';

export interface BayesianNetworkMxGraphJSON extends HCLTreeMxGraphJSON {
  [ReferenceTypes.BAYESIAN_NODES]: {[key: string]: BayesianNodeJSON };
}

export interface BayesianNodeJSON {
  states: {[key: string]: BayesianNodeStateJSON};
  dependencies: OutcomeJSON[];
  label: LabelJSON;
}

export interface BayesianNodeStateJSON {
  probabilities: BayesianNodeProbabilityJSON[];
}

export interface BayesianNodeProbabilityJSON {
  expression: ExpressionJSON;
  states: OutcomeJSON[];
}

class BayesianNetworkMxGraph extends HCLTreeMxGraph {
  constructor(onGraphMounted: () => void, onGraphUnmounted: () => void) {
    super(onGraphMounted, onGraphUnmounted, new BayesianNetworkMxGraphModel());
  }

  getVertexControlBoundsRulesForCellState(state: mxCellState): mxRectangle {
    // @ts-ignore
    return undefined;
  }

  onMountComplete(): void {
  }

  onUnmountComplete(): void {
  }

  onNotifyGraphMounted(): void {
  }

  createVertexHandler(state: mxCellState): BayesianNetworkMxVertexHandler {
    return new BayesianNetworkMxVertexHandler(state);
  }

  getDefaultLayout(): MxFastOrganicLayout {
    return new MxFastOrganicLayout(this);
  }

  setStyles(): void {
  }

  toggleSubTree(cell: mxCell, collapse: boolean): void {
  }

  populateFromJSON(inputJSON: BayesianNetworkMxGraphJSON): void {
    new BayesianNetworkMxGraphDecoder(this, inputJSON).decode();
  }

  public createCellRenderer(): BayesianNetworkMxCellRenderer {
    return new BayesianNetworkMxCellRenderer();
  }

  toJSON(): {[index: string]: any} {
    return new BayesianNetworkMxGraphEncoder(this).encode();
  }

  createStylesheet(): BayesianNetworkMxStylesheet {
    return new BayesianNetworkMxStylesheet();
  }

  public createSelectionModel(): BayesianNetworkMxGraphSelectionModel {
    return new BayesianNetworkMxGraphSelectionModel(this);
  }

  public addVertexWithUniqueKey(vertex: HCLTreeVertex, parent: mxCell = this.getDefaultParent()): HCLTreeVertex {
    if (vertex instanceof BayesianNetworkVertex) {
      return super.addVertexWithUniqueKey(vertex, parent);
    }
    return null;
  }
}

export default BayesianNetworkMxGraph;
